import { render, staticRenderFns } from "./ocr.vue?vue&type=template&id=721f92ca&scoped=true&"
import script from "./ocr.vue?vue&type=script&lang=js&"
export * from "./ocr.vue?vue&type=script&lang=js&"
import style0 from "./ocr.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ocr.vue?vue&type=style&index=1&id=721f92ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721f92ca",
  null
  
)

export default component.exports